import { PageService } from "app/services/page-service";
import {
  Component,
  OnInit,
  Renderer2,
  ViewChild,
  ElementRef,
} from "@angular/core";
// ROUTES export removed/ unavailable; using local listTitles initialization instead
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { environment } from "environments/environment";

@Component({
  moduleId: module.id,
  selector: "navbar-cmp",
  templateUrl: "navbar.component.html",
})
export class NavbarComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  private nativeElement: Node;
  private toggleButton;
  private sidebarVisible: boolean;
  clientDetails = JSON.parse(localStorage.getItem("client"));
     logoImage = environment.navLogo ? environment.navLogo : "/assets/images/sidebarlogoIcon.png"
  defaultLogo =
    this.clientDetails && this.clientDetails["logo"]
      ? this.clientDetails["logo"]
      : this.logoImage;
   
  public isCollapsed = true;
  @ViewChild("navbar-cmp", { static: false }) button;
  userDetails: any;

  constructor(
    location: Location,
    private renderer: Renderer2,
    private element: ElementRef,
    private router: Router,
  ) {
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  ngOnInit() {
    // If ROUTES is not exported from modern-sidebar, initialize listTitles as empty.
    // Update this to load route titles from an appropriate source if needed.
    this.listTitles = [];
    var navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName("navbar-toggle")[0];
    this.router.events.subscribe((event) => {
      this.sidebarClose();
    });

    try {
      this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    } catch (err) {}
  }
  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === "#") {
      titlee = titlee.slice(1);
    }
    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return "Dashboard";
  }
  sidebarToggle() {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }
  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const html = document.getElementsByTagName("html")[0];
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );
    setTimeout(function () {
      toggleButton.classList.add("toggled");
    }, 500);

    html.classList.add("nav-open");
    if (window.innerWidth < 991) {
      mainPanel.style.position = "fixed";
    }
    this.sidebarVisible = true;
  }
  sidebarClose() {
    const html = document.getElementsByTagName("html")[0];
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );
    if (window.innerWidth < 991) {
      setTimeout(function () {
        mainPanel.style.position = "";
      }, 500);
    }
    if (this.toggleButton) {
      this.toggleButton.classList.remove("toggled");
    }
    this.sidebarVisible = false;
    html.classList.remove("nav-open");
  }
  collapse() {
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName("nav")[0];
    if (!this.isCollapsed) {
      navbar.classList.remove("navbar-transparent");
      navbar.classList.add("bg-white");
    } else {
      navbar.classList.add("navbar-transparent");
      navbar.classList.remove("bg-white");
    }
  }
  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("selectedCityData");
    localStorage.removeItem("customerId");
    localStorage.removeItem("accountRole");
    localStorage.removeItem("permissionData");
    localStorage.removeItem("moduleAccessbyUser");
    localStorage.removeItem("userDetails");
    localStorage.removeItem("customerCacheSearch");
    localStorage.removeItem("categoriesCacheSearch");
    localStorage.removeItem("deliveryPartnersCacheSearch");
    localStorage.removeItem("couponsCacheSearch");
    localStorage.removeItem("cruzoSupportCacheSearch");
    localStorage.removeItem("orderCacheSearch");
    localStorage.removeItem("productCacheSearch");
    localStorage.removeItem("orderRatingCacheSearch");
    localStorage.removeItem("productRatingsCacheSearch");
    localStorage.removeItem("sellerRatingCacheSearch");
    localStorage.removeItem("sellersCacheSearch");
    localStorage.removeItem("supportsCacheSearch");
    const appName = localStorage.getItem("clientName");
    this.router.navigate(["/login"]);
  }
}
